import { render, staticRenderFns } from "./RecordingNotification.vue?vue&type=template&id=0c850028&"
import script from "./RecordingNotification.vue?vue&type=script&lang=js&"
export * from "./RecordingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c850028')) {
      api.createRecord('0c850028', component.options)
    } else {
      api.reload('0c850028', component.options)
    }
    module.hot.accept("./RecordingNotification.vue?vue&type=template&id=0c850028&", function () {
      api.rerender('0c850028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/RecordingNotification.vue"
export default component.exports